import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Link from "../../link"
import { FormattedMessage, useIntl } from "react-intl"

const CardCompaniesHomePage = () => {
  /**
   * Utility for adding a common query param to the thumbnail images.
   * There's a bug with handling this in CosmicJS.
   * @param url
   * @returns {string}
   */
  const { locale } = useIntl();
  const imgixUrl = url => {
    const q = "?q=&auto=compress,&w=113&h=113"
    return url + q
  }

  return (
    <StaticQuery
      query={graphql`
        {
          allCosmicjsCompanies(
            limit: 3
            filter: { metadata: { company_featured: { eq: true } } }
          ) {
            edges {
              node {
                id
                title
                locale
                slug
                metadata {
                  company_logo {
                    imgix_url
                  }
                  company_one_word
                }
              }
            }
          }
        }
      `}
      render={data =>
        data.allCosmicjsCompanies.edges.filter(({ node }) => node.locale === locale).map(({ node }, idx) => {
          return (
            <div
              key={idx}
              className="card component-card component-card-company-partners"
            >
              <Link to={`/company/${node.slug}`}>
                <img
                  src={imgixUrl(node.metadata.company_logo?.imgix_url)}
                  alt={node.slug}
                />
              </Link>
              <h3 className="company">{node.title}</h3>
              <p className="one-word">
                <FormattedMessage
                  id="one-word-that-describes-us"
                  defaultMessage="One word that describes us"
                />:{" "}
                <strong>{node.metadata.company_one_word}</strong>
              </p>
            </div>
          )
        })
      }
    />
  )
}

export default CardCompaniesHomePage
